import { render, staticRenderFns } from "./StoreQueueList.vue?vue&type=template&id=3b79b8ad&scoped=true&"
import script from "./StoreQueueList.vue?vue&type=script&lang=js&"
export * from "./StoreQueueList.vue?vue&type=script&lang=js&"
import style0 from "./StoreQueueList.vue?vue&type=style&index=0&id=3b79b8ad&lang=less&scoped=true&"
import style1 from "./StoreQueueList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b79b8ad",
  null
  
)

export default component.exports